var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 15 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.287 13a.37.37 0 0 0 .285-.127.343.343 0 0 0 .075-.296l-.835-3.939 3.07-2.71a.345.345 0 0 0 .1-.369.36.36 0 0 0-.305-.24L9.548 4.87 7.832 1.209A.364.364 0 0 0 7.5 1a.363.363 0 0 0-.332.209L5.452 4.87l-4.129.449a.36.36 0 0 0-.305.24.342.342 0 0 0 .101.369l3.07 2.71-.836 3.939a.346.346 0 0 0 .141.354c.115.082.268.09.392.024L7.5 10.966l3.614 1.989a.375.375 0 0 0 .173.045",
    stroke: "#FFF",
    strokeWidth: 1.3,
    fillRule: "nonzero",
    fill: "#fff"
  })));
};
export default SvgStar;